import { SxProps, Typography } from '@mui/material';
import Link from '../../shared/link';

const footerTypographyStyle: SxProps = {
  textAlign: 'center',
  marginTop: 3,
};

function SwitchFormFooter({
  text,
  linkText,
  onSwitch,
}: {
  linkText: string;
  onSwitch: () => void;
  text: string;
}) {
  const handleClickLink = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    onSwitch();
  };

  return (
    <Typography sx={footerTypographyStyle} variant="body2">
      {text}{' '}
      <Link href="#" onClick={handleClickLink}>
        {linkText}
      </Link>
    </Typography>
  );
}

export default SwitchFormFooter;
